import React, { useContext, useState } from 'react';
import { store } from './Driver';
import { store as mainStore } from '../../../../../../store';
import { DataGrid } from '@material-ui/data-grid';
import Skeleton from '@material-ui/lab/Skeleton';
import { localText } from '../../../../../../langs/fa/data-grid';
import moment from 'moment-jalaali';
import { __ } from '../../../../../../utils/i18n';
import { useHistory, useParams } from 'react-router-dom';
import NoTransactions from './NoTransactions';
import formatNumber from '../../../../../../fns/formatNumber';

const Transactions = () => {
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const { state, dispatch } = useContext(store);
  const { fetchingTransactions } = state;
  let { transactions } = state;
  const {
    state: {
      Auth: {
        profile: { username },
      },
    },
  } = useContext(mainStore);
  // const { itemsCountPerPage } = mainState.Props;
  const columns = [
    { field: 'creator', headerName: 'ایجادکننده', width: 150 },
    { field: 'amount', headerName: 'مبلغ', width: 150 },
    { field: 'transactionType', headerName: 'نوع تراکنش', width: 150 },
    { field: 'description', headerName: 'شرح', flex: 1 },
    { field: 'createdAt', headerName: 'زمان', width: 180 },
  ];
  const history = useHistory();
  const isAdmin = username === 'admin';

  const handlePageChange = async ({ page }) => {
    if (transactions.page === page) return;
    setLoading(true);
    const res = await fetchingTransactions(id, page, transactions.limit);
    setLoading(false);
    dispatch({ type: 'LOAD', payload: { name: 'transactions', value: res } });
  };

  const getStatus = (type, isDepo, verified, paidAt) => {
    if (type === 'payCommission') return 'تسویه پورسانت';
    if (isDepo && !verified) return 'در انتظار تخلیه‌';
    if (isDepo && verified && !paidAt) return 'قابل پرداخت';
    if (isDepo && verified && paidAt) return 'پرداخت شده';
  };

  !isAdmin && (transactions = []);
  const _transactions =
    transactions?.docs?.map((t) => ({
      id: t._id,
      creator: `${t.creator.firstName} ${t.creator.lastName}`,
      amount: formatNumber(t.amount),
      transactionType: __(t.transactionType),
      description: t.description,
      createdAt: moment(t.createdAt).format('jYY/jMM/jDD hh:mm a'),
      status: getStatus(
        t.transactionType,
        t.isDepositCommission,
        t.verified,
        t.paidAt
      ),
    })) || [];

  //   const handleSelectOrder = (order) => {
  //     history.push(`/protected/admin/orders/${[order.rowIds]}`);
  //   };
  return (
    <>
      <h4>ریز تراکنش‌ها:</h4>
      <div style={{ height: 300, width: '100%' }}>
        {transactions ? (
          <DataGrid
            rows={_transactions}
            columns={columns}
            localeText={localText}
            pageSize={
              transactions && transactions.limit ? transactions.limit : 0
            }
            rowCount={
              transactions && transactions.totalDocs
                ? transactions.totalDocs
                : 0
            }
            paginationMode="server"
            onPageChange={handlePageChange}
            loading={loading}
            disableMultipleSelection
            density="compact"
            components={{
              noRowsOverlay: NoTransactions,
            }}
            // onSelectionChange={handleSelectOrder}
          />
        ) : (
          <Skeleton height={300} variant="rect" animation="wave" />
        )}
      </div>
    </>
  );
};

export default React.memo(Transactions);
